/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const listStatusesFilteredByDeliveryGroupNoWithUser = /* GraphQL */ `query ListStatusesFilteredByDeliveryGroupNoWithUser(
  $user_id: ID
  $delivery_group_no: String
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listStatusesFilteredByDeliveryGroupNoWithUser(
    user_id: $user_id
    delivery_group_no: $delivery_group_no
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      serial_no
      delivery_group_no
      time
      status_flag
      status
      latitude
      longitude
      created_at
      ttl_timestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStatusesFilteredByDeliveryGroupNoWithUserQueryVariables,
  APITypes.ListStatusesFilteredByDeliveryGroupNoWithUserQuery
>;
export const listStatusesFilteredBySerialNoWithUser = /* GraphQL */ `query ListStatusesFilteredBySerialNoWithUser(
  $user_id: ID
  $serial_no: String
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listStatusesFilteredBySerialNoWithUser(
    user_id: $user_id
    serial_no: $serial_no
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      serial_no
      delivery_group_no
      time
      status_flag
      status
      latitude
      longitude
      created_at
      ttl_timestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStatusesFilteredBySerialNoWithUserQueryVariables,
  APITypes.ListStatusesFilteredBySerialNoWithUserQuery
>;
export const listDriverSetFilteredByDriverPin = /* GraphQL */ `query ListDriverSetFilteredByDriverPin(
  $user_id: ID
  $driver_pin: String!
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listDriverSetFilteredByDriverPin(
    user_id: $user_id
    driver_pin: $driver_pin
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      delivery_date
      serial_no
      driver_pin
      dgn
      created_at
      ttl_timestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDriverSetFilteredByDriverPinQueryVariables,
  APITypes.ListDriverSetFilteredByDriverPinQuery
>;
export const listStatusFilteredBySerialNoAndDateTimeRangeWithUser = /* GraphQL */ `query ListStatusFilteredBySerialNoAndDateTimeRangeWithUser(
  $user_id: ID
  $startDateTime: Int!
  $endDateTime: Int!
  $serial_no: String
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listStatusFilteredBySerialNoAndDateTimeRangeWithUser(
    user_id: $user_id
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    serial_no: $serial_no
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      serial_no
      delivery_group_no
      time
      status_flag
      status
      latitude
      longitude
      created_at
      ttl_timestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStatusFilteredBySerialNoAndDateTimeRangeWithUserQueryVariables,
  APITypes.ListStatusFilteredBySerialNoAndDateTimeRangeWithUserQuery
>;
export const listVehicleSubscriptionByDeliveryPlanIdAndTopic = /* GraphQL */ `query ListVehicleSubscriptionByDeliveryPlanIdAndTopic(
  $user_id: ID
  $delivery_plan_id: String!
  $topic: String!
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listVehicleSubscriptionByDeliveryPlanIdAndTopic(
    user_id: $user_id
    delivery_plan_id: $delivery_plan_id
    topic: $topic
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      serial_no
      tm
      topic
      payload
      id
      delivery_plan_id
      created_at
      ttl_timestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVehicleSubscriptionByDeliveryPlanIdAndTopicQueryVariables,
  APITypes.ListVehicleSubscriptionByDeliveryPlanIdAndTopicQuery
>;
export const listVehicleSubscriptionBySnAndTopic = /* GraphQL */ `query ListVehicleSubscriptionBySnAndTopic(
  $user_id: ID
  $topic: String!
  $serial_no: String!
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listVehicleSubscriptionBySnAndTopic(
    user_id: $user_id
    topic: $topic
    serial_no: $serial_no
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      serial_no
      tm
      topic
      payload
      id
      delivery_plan_id
      created_at
      ttl_timestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVehicleSubscriptionBySnAndTopicQueryVariables,
  APITypes.ListVehicleSubscriptionBySnAndTopicQuery
>;
export const listVehicleSubscriptionBySnAndTopicAndDateTimeRange = /* GraphQL */ `query ListVehicleSubscriptionBySnAndTopicAndDateTimeRange(
  $user_id: ID
  $topic: String!
  $startDateTime: Int!
  $endDateTime: Int!
  $serial_no: String!
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listVehicleSubscriptionBySnAndTopicAndDateTimeRange(
    user_id: $user_id
    topic: $topic
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    serial_no: $serial_no
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      serial_no
      tm
      topic
      payload
      id
      delivery_plan_id
      created_at
      ttl_timestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVehicleSubscriptionBySnAndTopicAndDateTimeRangeQueryVariables,
  APITypes.ListVehicleSubscriptionBySnAndTopicAndDateTimeRangeQuery
>;
export const listVehicleSubscriptionFilteredByDgnAndTopicAndDateTimeRangeWithUser = /* GraphQL */ `query ListVehicleSubscriptionFilteredByDgnAndTopicAndDateTimeRangeWithUser(
  $user_id: ID
  $topic: String!
  $delivery_plan_id: String!
  $startDateTime: Int!
  $endDateTime: Int!
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listVehicleSubscriptionFilteredByDgnAndTopicAndDateTimeRangeWithUser(
    user_id: $user_id
    topic: $topic
    delivery_plan_id: $delivery_plan_id
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      serial_no
      tm
      topic
      payload
      id
      delivery_plan_id
      created_at
      ttl_timestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVehicleSubscriptionFilteredByDgnAndTopicAndDateTimeRangeWithUserQueryVariables,
  APITypes.ListVehicleSubscriptionFilteredByDgnAndTopicAndDateTimeRangeWithUserQuery
>;
export const listStatusFilteredByDeliveryGroupNoAndDateTimeRangeWithUser = /* GraphQL */ `query ListStatusFilteredByDeliveryGroupNoAndDateTimeRangeWithUser(
  $user_id: ID
  $delivery_group_no: String!
  $startDateTime: Int!
  $endDateTime: Int!
  $limit: Int
  $nextToken: String
  $sortDirection: String
) {
  listStatusFilteredByDeliveryGroupNoAndDateTimeRangeWithUser(
    user_id: $user_id
    delivery_group_no: $delivery_group_no
    startDateTime: $startDateTime
    endDateTime: $endDateTime
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      serial_no
      delivery_group_no
      time
      status_flag
      status
      latitude
      longitude
      created_at
      ttl_timestamp
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStatusFilteredByDeliveryGroupNoAndDateTimeRangeWithUserQueryVariables,
  APITypes.ListStatusFilteredByDeliveryGroupNoAndDateTimeRangeWithUserQuery
>;
